// Hover a gallery thumbnail to change the main image (Swiper thumbs stay click-driven).
// Pointer-only: touch devices fire a synthetic hover on tap, which would double up with the click.
(() => {
  const MAIN_SELECTOR = '.carousel-media__slider--main';
  const bound = new WeakSet();

  const slideSpeed = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : undefined;

  const bind = (mainElement) => {
    const mainSwiper = mainElement.swiper;
    const thumbSwiper = mainSwiper?.thumbs?.swiper;
    if (!mainSwiper || !thumbSwiper || bound.has(mainElement)) return;
    bound.add(mainElement);

    thumbSwiper.slides.forEach((slide, index) => {
      slide.addEventListener('mouseenter', () => {
        if (mainSwiper.destroyed) return;
        mainSwiper.slideTo(index, slideSpeed());
      });
    });
  };

  const scan = () => {
    document.querySelectorAll(MAIN_SELECTOR).forEach((element) => {
      if (element.swiper) bind(element);
    });
  };

  // Swiper initialises asynchronously, so watch for it rather than polling.
  const start = () => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    scan();

    const pending = [...document.querySelectorAll(MAIN_SELECTOR)].filter((element) => !element.swiper);
    if (!pending.length) return;

    const observer = new MutationObserver(() => {
      scan();
      if (![...document.querySelectorAll(MAIN_SELECTOR)].some((element) => !element.swiper)) {
        observer.disconnect();
      }
    });
    pending.forEach((element) => observer.observe(element, { attributes: true, attributeFilter: ['class'] }));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  // The section can re-render in the theme editor, and re-run this file with it.
  if (!document.documentElement.dataset.thumbHoverBound) {
    document.documentElement.dataset.thumbHoverBound = 'true';
    document.addEventListener('shopify:section:load', start);
  }
})();
